import { create } from 'zustand'

/**
 * Whether `MobileFab` is currently drawing TWO stacked buttons (the
 * quick-capture "Report on plan" above the "+"), which doubles the height of
 * the right-hand lane above the tab bar.
 *
 * Published by `MobileFab`, the only component that knows, so that bottom
 * cards spanning the full width can clear the taller lane without calling
 * `useQuickCaptureEntry` a second time — that hook reads the stage's pilot flag
 * fresh on every screen entry, and a second instance would spend a second read.
 */
type MobileFabState = {
  stacked: boolean
  setStacked: (stacked: boolean) => void
}

export const useMobileFabStore = create<MobileFabState>(set => ({
  stacked: false,
  setStacked: stacked => set({ stacked }),
}))
